import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_ACTOR_TYPES_KEY } from '@/keys';
import type { ActorType } from '@/types/core/purchase-order/actor-type';

async function getActorTypes(): Promise<ActorType[]> {
  const response = await api.get<ActorType[]>('/actor-types');

  return response.data;
}

export function useGetActorTypes(): UseQueryResult<ActorType[], Error> {
  return useQuery({
    queryKey: GET_ACTOR_TYPES_KEY,
    queryFn: getActorTypes,
  });
}
